'use client';

import styles from './PlaylistPage.module.css';
import { useAudioPlayer } from '@/context/AudioPlayerContext';
import TrackList from '@/components/TrackList';
import ShareMenuButton from '@/components/ShareMenuButton';
import { useState, useEffect } from 'react';
import SectionWithPlayAll from '@/components/SectionWithPlayAll'; // 👈 импортируем секцию
import PlaylistSlider from '@/components/PlaylistSlider'; // 👈 импортируем слай


interface Track {
  id: number;
  title: string;

  imageUrl?: string;
  composer?: string;
  duration?: string;
  workId?: number;
  slug: string;
  isFavorited?: boolean;
}

interface PlaylistTrack {
  song: Track;
}

interface Playlist {
  id: number;
  title: string;
  description?: string;
  imageUrl?: string;
  playlisttrack: PlaylistTrack[];
  slug: string;
  isFavorited?: boolean;
}

interface CoverSources {
  src: string;
  srcSet?: string;
}

interface Props {
  playlist: Playlist;
  coverSources: CoverSources;
}



export default function PlaylistPageClient({
  playlist,
  coverSources,
}: Props) {
  const {
    isPlaying,
    pause,
    playPlaylist,
    currentPlaylistId,
    resume,
  } = useAudioPlayer();

  const isActivePlaylist = currentPlaylistId === playlist.id;


  const handlePlayClick = () => {
  if (isActivePlaylist) {
    resume();
  } else {
    playPlaylist(
      { ...playlist, _type: 'playlist' },
      playlist.id,
      'playlist'
    );
  }
};

  const handlePauseClick = () => {
    pause(); // ⏸️ останавливаем воспроизведение
  };

  const [recommendations, setRecommendations] = useState<unknown[]>([]);

  useEffect(() => {
    const loadRecommendations = async () => {
      try {
        const res = await fetch(`/api/playlist-recommendations?slug=${playlist.slug}`);
        const data = await res.json();
        setRecommendations(data.recommendations || []);
      } catch (err) {
        console.error('Failed to load playlist recommendations:', err);
      }
    };
    loadRecommendations();
  }, [playlist.slug]);



  return (

    <div className={styles.container}>
      <div className={styles.coverWrapper}>
        <img
          src={coverSources.src}
          srcSet={coverSources.srcSet}
          sizes="(max-width: 1200px) calc(100vw - 2rem), calc(100vw - 6rem)"
          alt={playlist.title}
          className={styles.cover}
        />
      </div>

      <div className={styles.info}>
        <h2 className={styles.title}>{playlist.title}</h2>
        <p className={styles.description}>{playlist.description}</p>

        <div className={styles.actionRow}>
          {isActivePlaylist && isPlaying ? (
            <button
              onClick={handlePauseClick}
              className={styles.playButton}
              aria-label="Pause"
            >
              <img src="/icons/pause100-new.png" alt="Pause" className={styles.icon} />
            </button>
          ) : (
            <button
              onClick={handlePlayClick}
              className={styles.playButton}
              aria-label="Play"
            >
              <img src="/icons/play-new.png" alt="Play" className={styles.icon} />
            </button>
          )}
          <ShareMenuButton item={playlist} type="playlist" />
        </div>
      </div>

      <TrackList
        tracks={playlist.playlisttrack.map(pt => ({
          id: pt.song.id,
          title: pt.song.title,
          slug: pt.song.slug,
          composer: pt.song.composer ?? '',
          duration: pt.song.duration ?? '',
          imageUrl: pt.song.imageUrl ?? '/placeholder.jpg', // 👈 так ты гарантируешь, что всегда будет картинка
          isFavorited: pt.song.isFavorited ?? false,
        }))}
      />
      <SectionWithPlayAll title="You Might Also Like" songs={recommendations}>
        <PlaylistSlider items={recommendations} />
      </SectionWithPlayAll>
    </div >

  );
}
